import apiClient from '@/shared/services/apiClient'
import type { BatchQuestionSolutionResponse } from '../types'

interface ApiResponse<T> {
  success: boolean
  message: string
  data: T
  timestamp: string
}

const solutionBrowserService = {
  /**
   * Fetch solution data for a batch of questions by ID
   * POST /api/v1/question-bank/questions/batch/solutions
   */
  async getBatchSolutions(questionIds: string[], userId?: string): Promise<ApiResponse<BatchQuestionSolutionResponse>> {
    const response = await apiClient.post<ApiResponse<BatchQuestionSolutionResponse>>(
      '/api/v1/question-bank/questions/batch/solutions',
      questionIds,
      {
        params: userId ? { userId } : undefined,
      }
    )
    return response.data
  },
}

export default solutionBrowserService
